const MDI_LUCIDE_MAP = {
  "mdi-view-dashboard": "LayoutDashboard",
  "mdi-chart-bar": "BarChart3",
  "mdi-chart-line": "LineChart",
  "mdi-chart-ppf": "PieChart",
  "mdi-checkbox-marked-outline": "SquareCheck",
  "mdi-calendar-today": "Calendar",
  "mdi-calendar-clock": "CalendarClock",
  "mdi-ticket-percent": "Percent",
  "mdi-ribbon": "Award",
  "mdi-account-wrench": "Wrench",
  "mdi-cogs": "Settings",
  "mdi-progress-upload": "Upload",
  "mdi-database-arrow-right": "Database",
  "mdi-ticket": "Ticket",
  "mdi-ticket-account": "Ticket",
  "mdi-ticket-confirmation-outline": "TicketCheck",
  "mdi-ticket-confirmation": "TicketCheck",
  "mdi-close-octagon-outline": "OctagonX",
  "mdi-close-box-multiple": "ArchiveX",
  "mdi-email-variant": "Mail",
  "mdi-timer-sand": "Hourglass",
  "mdi-check-decagram": "BadgeCheck",
  "mdi-check-circle": "CircleCheck",
  "mdi-lumx": "Package",
  "mdi-pandora": "Box",
  "mdi-tag": "Tag",
  "mdi-weather-sunset-up": "Sunrise",
  "mdi-account-tie": "UserCog",
  "mdi-account-supervisor-circle": "Users",
  "mdi-account-multiple-outline": "Users",
  "mdi-account-hard-hat": "HardHat",
  "mdi-account-hard-hat-outline": "HardHat",
  "mdi-human-greeting": "Handshake",
  "mdi-clipboard-text-multiple": "ClipboardList",
  "mdi-backup-restore": "RotateCcw",
  "mdi-refresh": "RefreshCw",
  "mdi-reload": "RefreshCw",
  "mdi-map-marker-distance": "MapPin",
  "mdi-open-in-new": "ExternalLink",
  "mdi-vector-square": "Square",
  "mdi-share": "Share2",
  "mdi-store": "Store",
  "mdi-store-check-outline": "Store",
  "mdi-account-group": "UsersRound",
  "mdi-account-group-outline": "UsersRound",
  "mdi-account-multiple-remove-outline": "UserX",
  "mdi-human-queue": "Users",
  "mdi-wrench": "Wrench",
  "mdi-briefcase": "Briefcase",
  "mdi-briefcase-check": "BriefcaseBusiness",
  "mdi-form-select": "FileText",
  "mdi-step-forward": "StepForward",
  "mdi-home-group-plus": "Home",
  "mdi-selection-multiple-marker": "MapPinned",
  "mdi-find-replace": "Replace",
  "mdi-bookmark-remove": "BookmarkX",
  "mdi-list-status": "ListChecks",
  "mdi-copyright": "Copyright",
  "mdi-chemical-weapon": "FlaskConical",
  "mdi-cog": "Cog",
  "mdi-cog-outline": "Settings",
  "mdi-math-log": "ScrollText",
  "mdi-cash-100": "Banknote",
  "mdi-cart": "ShoppingCart",
  "mdi-credit-card": "CreditCard",
  "mdi-currency-inr": "IndianRupee",
  "mdi-face-agent": "Headset",
  "mdi-alert": "AlertTriangle",
  "mdi-material-design": "Palette",
  "mdi-menu": "Menu",
  "mdi-chevron-down": "ChevronDown",
  "mdi-chevron-left": "ChevronLeft",
  "mdi-chevron-right": "ChevronRight",
  "mdi-logout": "LogOut",
  "mdi-lifebuoy": "LifeBuoy",
  "mdi-bell": "Bell",
  "mdi-bell-outline": "Bell",
  "mdi-bell-off": "BellOff",
  "mdi-bell-off-outline": "BellOff",
  "mdi-bug": "Bug",
  "mdi-bug-outline": "Bug",
  "mdi-camera-outline": "Camera",
  "mdi-video-outline": "Video",
  "mdi-stop-circle-outline": "Square",
  "mdi-moon-waning-crescent": "Moon",
  "mdi-white-balance-sunny": "Sun",
};

export function resolveLucideIcon(name) {
  if (!name) return "Circle";
  if (MDI_LUCIDE_MAP[name]) return MDI_LUCIDE_MAP[name];
  if (!name.startsWith("mdi-")) {
    const pascal = name
      .split("-")
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join("");
    return pascal;
  }
  return "CircleDot";
}
